import { Injectable } from '@angular/core';
import { Draw } from 'ol/interaction';
import { MapService } from './map.service';

import olMap from 'ol/Map';
import { NavaidDTOCalculation, NavaidModel, NavaidSitingToolModel } from '../models/navaid';
import VectorSource from 'ol/source/Vector';
import { PointsService } from './points.service';
import { ModalControlService } from './modal-control.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NavaidSitingToolComponent } from '../popup/calculations/navaid-siting-tool/navaid-siting-tool.component';
import { ConfigurationService } from './configuration.service';
import { PendingCalculation, PendingCalculationType } from '../models/pendingCalculation';
import { FeatureType } from '../models/EnumTypes';
import { Feature } from 'ol';
import { Geometry } from 'ol/geom';
import { ValidationModalService } from './validation-modal.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class SitingToolService {

  draw: Draw;

  constructor(private mapService: MapService, private pointsService: PointsService,
    private modalService: ModalControlService, private popupService: BsModalService,
    private configurationService: ConfigurationService, private validationModalService: ValidationModalService,
    private utilsService: UtilsService) {

  }


  sitingToolAreaInitialization(event : any){
    const sitingToolModel : NavaidSitingToolModel = new NavaidSitingToolModel();
    sitingToolModel.type = event;
    sitingToolModel.flightLevel = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT;
    sitingToolModel.flightLevelMeters = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeM;
    const navaidsFeaturesSelected = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
    const pendingCalculation: PendingCalculation = new PendingCalculation();
    pendingCalculation.selectedFeatures = navaidsFeaturesSelected;
    pendingCalculation.calculationDTO = sitingToolModel;
    pendingCalculation.calculationType = PendingCalculationType.SITING_TOOL;
    this.pointsService.getNavaidFeatureElevationMetersBulkInitialization(navaidsFeaturesSelected, pendingCalculation);
  }

  resumeSitingToolArea(navaidsFeaturesSelected: Feature<Geometry>[], navaidsEffectiveHeight: number[], sitingToolModel: NavaidSitingToolModel, navaidsTerrainHeight: number[]){
    if (!navaidsEffectiveHeight || navaidsEffectiveHeight.length != navaidsFeaturesSelected.length){
      this.modalService.showMesssageModal(
        `Calculation unsuccessful - Terrain Height`,
        `The was an error while performing the calculation: Terrain Height. Please confirm all the data and try again.`
      );
      return;
    }
    const navaids : NavaidDTOCalculation[] = [];
    const invalidNavaids : NavaidModel[] = [];
    for (let i = 0; i<navaidsFeaturesSelected.length; i++) {
      const navaid : NavaidModel = this.pointsService.transformFeatureInNavaid(navaidsFeaturesSelected[i]);
      const dtoCalculation: NavaidDTOCalculation = this.pointsService.transformFeatureInNavaidCalculationDTO(navaidsFeaturesSelected[i]);
      dtoCalculation.effectiveHeight = navaidsEffectiveHeight[i];
      navaid.effectiveHeight = navaidsEffectiveHeight[i];
      if (!this.utilsService.navaidHasRequiredGeneralCalculationsFields(navaid)) {
        invalidNavaids.push(navaid);
      }
      
      navaids.push(dtoCalculation);
    }
    if(navaids.length == 0){
      this.modalService.showMesssageModal("Siting Tool", "Select at least 1 Navaid to perform the calculation.");
      return;
    }

    sitingToolModel.navaids = navaids;
    if (invalidNavaids.length > 0) {
      navaidsTerrainHeight = null;
      this.validationModalService.showModal(null, null, sitingToolModel, invalidNavaids,null, "SitingTool", navaidsTerrainHeight)
      this.modalService.showMesssageModal("Siting Tool", "Some of navaids selected doesn't have DOC. Fix them before continue.");
    }
    else{
      this.openSitingToolArea(sitingToolModel);
    }
  }
  clearSitingToolDraw(){
    if (this.draw != null) {
      this.mapService.getMap('map').removeInteraction(this.draw);
    }
  }

  openSitingToolArea(model: NavaidSitingToolModel): void {
    this.modalService.showMesssageModal("Area Of Interest Selection","Please select the area on the map to perform NavAid siting.");
    this.clearSitingToolDraw();
    if (this.mapService.draw != null) {
      this.mapService.getMap('map').removeInteraction(this.mapService.draw);
      this.mapService.getMap('map').removeInteraction(this.mapService.select);
      this.mapService.draw = null;
    }
    const source = new VectorSource();
    let type: any = model.type;
    let freeHand: boolean = false;
    if (model.type == "Freehand") {
      freeHand = true;
      type = "Polygon";
    }
    this.draw = new Draw({
      source: source,
      type: type,
      freehand: freeHand,
    });
    this.mapService.getMap('map').addInteraction(this.draw);
    let context = this;
    this.draw.on('drawend', function (endEvent) {
      var interceptedNavaids: NavaidModel[] = [];
      var geometry = endEvent.feature.getGeometry();
      var extent = geometry.getExtent();
      context.pointsService.navaidsLayers.childLayers.forEach(child => {
        child.layers.forEach(layer => {
          if (layer.visible) {
            layer.olLayer.getSource().forEachFeatureIntersectingExtent(extent, function (feature) {
              if (geometry.intersectsExtent(feature.getGeometry().getExtent())) {
                interceptedNavaids.push(context.pointsService.transformFeatureInNavaid(feature));
              }
            });
          }
        })
      });
      var isInterceptingNavaids: Boolean = false;
      interceptedNavaids.forEach(navaid => {
        let existNavaid = model.navaids.findIndex(el => el.id == navaid.navaidid && el.type == navaid.navaidtype);
        if (existNavaid > -1) {
          isInterceptingNavaids = true;
          context.modalService.showMesssageModal("Siting Tool", "The siting tool area can not contain selected navaids. \nPlease start the siting tool again and redraw the siting tool area.");
          return;
        }
      });
      context.mapService.getMap('map').removeInteraction(context.draw);
      context.draw = null;
      if (!isInterceptingNavaids) {
        let bsModalRef: BsModalRef = context.popupService.show(NavaidSitingToolComponent);
        bsModalRef.content.feature = endEvent.feature;
        bsModalRef.content.model = model;
      };
    });
  }
}
